import { Base } from '../base-component';
import './banner-mid-page-video.component.scss';

export class BannerMidPageVideo extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/banner-mid-page-video/banner-mid-page-video.component.ts